<template>
	<div class="modal-erro">
		<!-- MODAL QUANDO O TOKEN EXPIRA -->
		<modal index="11189" ref="modalLogin">
			<form @submit.prevent="validaLogin">
				<div class="row">
					<div class="col-md-12">
						<h4>{{ titulo.titulo.toUpperCase() }}</h4>
					</div>
				</div>

				<hr class="first-separator" />

				<div class="row">
					<div class="col-xs-12">
						<div class="row modal-login__form-inner-body">
							<div class="col-xs-4 text-center">
								<div v-show="foto != ''">
									<img :src="foto" class="img-circle modal-login__img" />
								</div>

								<div v-show="foto == ''">
									<div class="div-nome">
										<p class="div-texto">{{ nomeReduzido }}</p>
									</div>
								</div>
							</div>
							<div class="col-xs-8">
								<h3 class="modal-login__form-last-group-title">{{ nome }}, {{ _traducao('global', 'suaSessaoExpirou') }}</h3>

								<h3>
									{{ _traducao('global', 'digiteSuaSenhaParaRenovala') }}
								</h3>

								<div class="form-group">
									<label>{{ _traducao('menuAGnovoUsuario', 'menuAGlogin') }}: </label>
									<input v-model="login" type="text" disabled="disabled" class="form-control input-sm" />
								</div>
								<div class="form-group" :class="{'has-error': erroSenha != ''}">
									<label>{{ _traducao('menuAGnovoUsuario', 'menuAGsenha') }}: </label>
									<input v-model="senha" type="password" class="form-control input-sm" />
									<p class="help-block" v-show="erroSenha != ''">{{ erroSenha }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<hr class="last-separator" />

				<div class="row">
					<div class="col-xs-12">
						<a href="#" class="btn btn-default" type="button" @click.prevent="clickSair()">
							<i class="icon icon-left fa-fw modal-login__form-footer-icon"></i>
							{{ _traducao('global', 'sair').toUpperCase() }}
						</a>
						<button class="btn btn-success pull-right">
							{{ _traducao('login', 'entrar').toUpperCase() }}
							<i class="fa fa-fw fa-check"></i>
						</button>
					</div>
				</div>
			</form>
		</modal>

		<!-- MODAL QUANDO GERA UM ERRO -->
		<modal index="11189" ref="modalErro" name="modal-erro">
			<div class="row">
				<div class="col-md-12">
					<button type="button" class="close" @click="fecharModal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>

			<hr class="first-separator" />

			<div class="row">
				<div class="col-xs-12">
					<div>
						<h3 class="text-danger">
							<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
							Oops! {{ _traducao('global', 'houveUmErroAoTentarAcessarOSeguinteEnderecoURL') }}:
						</h3>
						<h4 class="text-muted">
							{{ urlRequest }}
						</h4>
					</div>
				</div>

				<div class="col-xs-12" v-if="isDevelopment">
					<h4>
						<i class="fa fa-coffee" aria-hidden="true"></i>
						{{ _traducao('global', 'desenvolvedorVejaOErroRetornadoPeloBackEnd') }}:
					</h4>

					<iframe class="modal-erro__iframe" id="iframe"></iframe>
				</div>

				<div class="col-xs-12" v-else style="margin-top: 1em">
					<h4>
						<i class="fa fa-phone" aria-hidden="true"></i>
						{{ _traducao('global', 'seOErroPersistirPorFavorEntreEmContatoConosco') }}.
					</h4>
					<button class="btn btn-primary" @click="abrirChat" v-show="_getPrivilegio(260)">
						<i class="fa fa-commenting" aria-hidden="true"></i>
						{{ _traducao('global', 'abrirChat').toUpperCase() }}
					</button>
				</div>
			</div>

			<hr class="last-separator" />

			<div class="row">
				<div class="col-xs-12">
					<button type="button" class="btn btn-default pull-right" aria-label="Close" @click="fecharModal">
						<i class="fa fa-times"></i> {{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
	data() {
		return {
			erroTexto: '',

			login: '',
			senha: '',
			erroSenha: '',

			nome: '',
			nomeReduzido: '',
			foto: '',

			urlRequest: '',

			titulo: {
				titulo: ''
			},

			isDevelopment: process.env.NODE_ENV === 'development'
		}
	},

	mounted() {
		this.eventos()
	},

	methods: {
		eventos() {
			window.bus.$on('modal-erro-show', (obj, urlRequest = '') => {
				window.bus.$emit('load-out')
				this.validaErro(obj, urlRequest)
			})
		},

		validaErro(erro, urlRequest) {
			// token expirado
			if (erro.status == 408) {
				this.$refs.modalLogin.modalShow(40) // levanto modal para logar dinovo
				//this._exibeModal('modal-login', 40);
				this.titulo.titulo = this._traducao('global', 'sessaoExpirada')
				this.login = window.$sessao.getLogin()
				this.nome = window.$sessao.getNome().split(' ')[0]

				const nome = window.$sessao.getNome().split(' ')

				if (nome.length > 1) {
					this.nomeReduzido = nome[0].substring(0, 1) + nome[1].substring(0, 1)
				} else {
					this.nomeReduzido = nome[0].substring(0, 2)
				}

				if (window.$sessao.getFoto() != '') {
					//return "http://104.236.64.199/police/ws/foto/4e677897890bf6ace97b7a1abc9b42cf.jpg";
					this.foto = this._foto
				}
			} else if (erro.status != 0) {
				this._escondeModal('modal-alterar-senha')

				this.$nextTick(() => {
					if (!!document) {
						let iframe = document.getElementById('iframe')

						if (!!iframe && this.isDevelopment) {
							iframe.contentWindow.document.body.innerHTML = erro.responseText
						}

						this.urlRequest = urlRequest

						this.$refs.modalErro.modalShow(80)
					}
				})
			}
		},

		validaLogin: function () {
			this.erro = false

			if (this.senha.trim() == '') {
				this.erroSenha = this._traducao('global', 'vcTemQueDigitarSenha')
				return false
			} else {
				this.erroSenha = ''
			}

			this.textoLoad = ''
			this.exibirLoad = true

			window.bus.$emit('load-in', {text: this._traducao('login', 'entrando').toUpperCase()})

			const data = {
				login: this.login,
				senha: this.senha
			}

			this._httpPost('/Usuario/logar', data, (retorno) => {
				window.bus.$emit('load-out')

				this.exibirLoad = false

				if (retorno._request && retorno._status && retorno.token.trim() != '') {
					this.erro = false
					window.bus.$emit('exibir-notificacao', {type: 'success', text: this._traducao('global', 'sessaoAtualizada')})
					window.$sessao.setSessao(retorno.token, retorno.privilegios, retorno.area)
					this.$refs.modalLogin.modalHide()
				} else {
					this.erroSenha = this._traducao('global', 'senhaInvalida')
					window.bus.$emit('exibir-notificacao', {type: 'danger', text: this.erroSenha})
				}
			})
		},

		clickSair: function () {
			this.$refs.modalLogin.modalHide()
			window.$sessao.remove()
			this.$router.replace({name: 'login'})
		},

		abrirChat() {
			this.fecharModal()
			jivo_api.open()
		},

		fecharModal() {
			this.$refs.modalErro.modalHide()
		}
	}
}
</script>

<style scoped>
.first-separator {
	margin-bottom: 0px;
}

.last-separator {
	margin-bottom: 10px;
}

.modal-login__form-inner-body {
	margin-top: 16px;
	margin-bottom: 16px;
}

.modal-login__img {
	margin-left: 8px;
	border: 2px solid #999;
	height: 130px;
}

.modal-login__form-last-group-title {
	margin-top: 0px;
}

.modal-login__form-footer-icon {
	float: left;
	margin-right: 5px;
	margin-top: 2px;
}

.modal-erro__iframe {
	width: 100%;
	height: 400px;
}
</style>